<script setup>
// NOTICE: KAPTION-INTEGRATION
import { ref, onMounted, onUnmounted } from 'vue';
import { useResizeObserver } from '@vueuse/core';

const scrollContainer = ref(null);
const showTopGradient = ref(false);
const showBottomGradient = ref(false);

const updateScrollState = () => {
  if (!scrollContainer.value) return;
  const { scrollTop, scrollHeight, clientHeight } = scrollContainer.value;
  showTopGradient.value = scrollTop > 5;
  showBottomGradient.value =
    scrollHeight > clientHeight && scrollTop < scrollHeight - clientHeight - 5;
};

const onScroll = () => {
  updateScrollState();
};

// Watch for size changes in the container
useResizeObserver(scrollContainer, () => {
  updateScrollState();
});

onMounted(() => {
  updateScrollState();
  window.addEventListener('resize', updateScrollState);
});

onUnmounted(() => {
  window.removeEventListener('resize', updateScrollState);
});
</script>

<template>
  <div class="relative flex-grow min-h-0 group/scroll-container">
    <div
      class="absolute top-0 left-0 right-0 h-8 bg-gradient-to-b from-n-solid-2 to-transparent z-10 pointer-events-none transition-opacity duration-200"
      :class="showTopGradient ? 'opacity-100' : 'opacity-0'"
    />
    <nav
      ref="scrollContainer"
      class="h-full grid content-start gap-2 px-2 pb-5 overflow-y-scroll no-scrollbar"
      @scroll="onScroll"
    >
      <slot />
    </nav>
    <div
      class="absolute bottom-0 left-0 right-0 h-12 bg-gradient-to-t from-n-solid-2 to-transparent z-10 pointer-events-none transition-opacity duration-200 flex justify-center items-end pb-2"
      :class="showBottomGradient ? 'opacity-100' : 'opacity-0'"
    >
      <span
        class="i-lucide-chevron-down size-5 text-n-slate-11 animate-bounce"
      />
    </div>
  </div>
</template>
